import React, { useState } from "react";
import ReactMarkdown from "react-markdown";
import Discussion from "../Discussion/Discussion";
import RateReview from "../RateReview/RateReview";
import "./MenuTab.css";

function MenuTab({ description, resource }) {
  const [activeTab, setActiveTab] = useState(0);

  const tabContents = [
    { title: "About Class", content: description, type: "markdown" },
    { title: "Project & Resources", content: resource, type: "markdown" },
    { title: "Discussion", component: <Discussion />, type: "component" },
    { title: "Rate & Review", component: <RateReview />, type: "component" },
  ];

  return (
    <div className="menu-tab-container">
      <div className="menu-tab-header">
        {tabContents.map((tab, index) => (
          <button
            key={index}
            className={`tab-button ${index === activeTab ? "active" : ""}`}
            onClick={() => setActiveTab(index)}
          >
            {tab.title}
          </button>
        ))}
      </div>

      <div className="menu-tab-content">
        {tabContents[activeTab].type === "markdown" ? (
          <ReactMarkdown>{tabContents[activeTab].content}</ReactMarkdown>
        ) : (
          tabContents[activeTab].component
        )}
      </div>
    </div>
  );
}

export default MenuTab;
